module.exports = __webpack_public_path__ + "static/media/FaqIcon.d9f1bae1.svg";